<div class="loading-indicator" *ngIf="loading | async">
    <div class="loader">Loading...</div>
    <!-- <mat-spinner   mode="indeterminate" color="accent" diameter="100"></mat-spinner>	 -->
</div> <router-outlet></router-outlet>
